import type { audit as en } from '@/i18n/locales/en/audit';
import type { Translation } from '@/i18n/types';

export const audit: Translation<typeof en> = {
  page: {
    title: 'Registro di controllo',
    scopedLead:
      'Vedi le azioni consentite per le tue aziende; le risposte di consenso e i collegamenti di identità non sono mai inclusi.',
    actionFilter: 'Filtra per azione',
    actionPlaceholder: 'azione, es. department.visibility.update',
    scopeFilter: 'Filtra per ambito',
    scopePlaceholder: 'id ambito',
    filter: 'Filtra',
    empty: 'Nessuna riga di controllo.',
    when: 'Quando',
    action: 'Azione',
    actorRole: 'Ruolo dell’attore',
    target: 'Destinazione',
    rowsLabel: 'le righe di controllo',
  },
};
